import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string | null;
  display_order: number;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [faqs, setFaqs] = useState<FAQ[]>([]);

  useEffect(() => {
    async function fetchFAQs() {
      try {
        const { data, error } = await supabase
          .from('faq_items')
          .select('*')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (error) throw error;
        if (data) setFaqs(data);
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      }
    }

    fetchFAQs();
  }, []);

  return (
    <section className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Questions <span className="text-yellow-600">fréquentes</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed">
            Tout ce que vous devez savoir sur THE 21-DAY BUSINESS WEBSITE™
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-slate-50 transition-colors duration-200"
              >
                <span className="text-lg font-semibold text-slate-900 pr-8">
                  {faq.question}
                </span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-yellow-600 flex-shrink-0 transition-transform duration-300`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 text-slate-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-6">
            Vous avez d'autres questions ?
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center justify-center whitespace-nowrap cursor-pointer font-medium transition-all duration-300 bg-yellow-600 text-white hover:bg-yellow-700 shadow-lg hover:shadow-xl px-8 py-3.5 text-base"
          >
            Contactez-nous
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
